module.exports = __webpack_public_path__ + "media/images/covers/foundation/Kings-College-London-logo-6ddde48aaf5b92d42fc0b64d8ec461f3.svg";